import { createSelector } from 'reselect';

export const onboardingRequestsSelector = createSelector(
  (state) => state && state.onboarding && state.onboarding.requests,
  (requests) => requests || []
);
